var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "breadcrumb-layout" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "/" } },
          [
            _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
              _vm._v("交易单管理")
            ]),
            _vm._v(" "),
            _c("el-breadcrumb-item", [_vm._v("开票信息")])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "right",
            on: {
              click: function($event) {
                _vm.$router.back(-1)
              }
            }
          },
          [_vm._m(0)]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "form-info" }, [
      _c("div", { staticClass: "form-row" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _c("span", [_vm._v(_vm._s(_vm.voucher.no))])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.voucher.contractNo != null
        ? _c("div", { staticClass: "form-row" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("div", { staticClass: "value" }, [
                _c("span", [_vm._v(" " + _vm._s(_vm.voucher.contractNo))])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _vm.voucher.totalZxAmount == 0 && _vm.voucher.paidAmount > 0
              ? _c("span", [_vm._v("已预付款")])
              : _vm._e(),
            _vm._v(" "),
            parseFloat(_vm.voucher.paidAmount) <
              parseFloat(_vm.voucher.totalZxAmount) &&
            _vm.voucher.totalZxAmount != 0 &&
            _vm.voucher.paidAmount > 0 &&
            !_vm.voucher.payFinished
              ? _c("span", [_vm._v("部分付款")])
              : _vm._e(),
            _vm._v(" "),
            (parseFloat(_vm.voucher.paidAmount) >=
              parseFloat(_vm.voucher.totalZxAmount) &&
              _vm.voucher.totalZxAmount != 0) ||
            _vm.voucher.payFinished
              ? _c("span", [_vm._v("已付款")])
              : _vm._e(),
            _vm._v(" "),
            _vm.voucher.paidAmount == 0
              ? _c("span", [_vm._v("未付款")])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _c("span", [_vm._v(_vm._s(_vm.voucher.buyerName))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("hr", { staticClass: "dashed" }),
      _vm._v(" "),
      _vm.voucher.contractNo != null
        ? _c("div", { staticClass: "form-row" }, [
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("div", { staticClass: "value" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(parseFloat(_vm.voucher.estmtAmount || 0).toFixed(2))
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _c("span", [
              _vm._v(_vm._s(parseFloat(_vm.voucher.totalZxAmount).toFixed(2)))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(7),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _c("span", [
              _vm._v(_vm._s(parseFloat(_vm.voucher.paidAmount).toFixed(2)))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(8),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _c("span", [
              _vm._v(_vm._s(parseFloat(_vm.voucher.refundedAmount).toFixed(2)))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(9),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _c("span", [
              _vm._v(_vm._s(parseFloat(_vm.voucher.madeOutAmount).toFixed(2)))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(10),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _c("span", [
              _vm._v(
                _vm._s(
                  parseFloat(_vm.voucher.applingMakeOutAmount || 0).toFixed(2)
                )
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("hr", { staticClass: "dashed" }),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(11),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _c("span", [_vm._v(_vm._s(_vm.voucher.invoiceTypeText))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(12),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _c("span", [_vm._v(_vm._s(_vm.voucher.invoiceSubjectTypeText))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(13),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _c("span", [_vm._v(_vm._s(_vm.voucher.invoiceContentTag))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(14),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _c("span", [_vm._v(_vm._s(_vm.voucher.invoiceTitle))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(15),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "value" }, [
            _c("span", [_vm._v(_vm._s(_vm.voucher.taxPayerNo))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _vm._m(16),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.voucher.makeOutFinished
            ? _c("div", { staticClass: "value" }, [_vm._v("是")])
            : _c("div", { staticClass: "value" }, [_vm._v("否")])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "column-layout" }, [
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.invoiceVoucherList,
                border: "",
                "tooltip-effect": "dark"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "tradeNo",
                  align: "center",
                  label: "交易单号",
                  width: "183px;"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sellerName",
                  label: "客户名称",
                  width: "150px;"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "invoiceTypeText",
                  label: "发票类型",
                  width: "120px;"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "invoiceTitle",
                  label: "发票抬头",
                  width: "150px;"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "taxPayerNo",
                  label: "纳税人识别号",
                  width: "130px;"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "actualNo", label: "发票号", width: "120px;" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "electFlag",
                  align: "center",
                  label: "是否电子发票",
                  width: "120px;"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.electFlag
                          ? _c("span", [_vm._v("是")])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "amount",
                  label: "开票金额(元)",
                  width: "120px;",
                  align: "right"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "madeOut",
                  align: "center",
                  label: "是否已开票",
                  width: "120px;"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.madeOut ? _c("span", [_vm._v("是")]) : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "applyTime",
                  align: "center",
                  label: "申请日期",
                  width: "180px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "auditStateText", label: "审核状态" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "invalid",
                  align: "center",
                  label: "是否作废",
                  width: "100px;"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.invalid
                          ? _c("span", { staticClass: "font-red" }, [
                              _vm._v("是")
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block pagination-layout" },
        [
          _c("el-pagination", {
            staticClass: "mt10",
            attrs: {
              background: "",
              "page-size": _vm.pageSize,
              "page-sizes": _vm.pageSizes,
              "current-page": _vm.pageNumber,
              total: _vm.totalCount,
              layout: "total, sizes, prev, pager, next, jumper"
            },
            on: {
              "current-change": _vm.handlePageChange,
              "size-change": _vm.handleSizeChange
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "swb-btn swb-btn-link" }, [
      _c("i", { staticClass: "icon iconfont icon-fanhui2 mr5" }),
      _vm._v("返回")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("交易单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("合同编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("交易状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("客户名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("预计交易总金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("累计订单金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已支付金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已退款金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已开发票金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请中发票金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票主体类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票内容")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票抬头")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("纳税人识别号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("是否开票完毕")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e81ecc1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e81ecc1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/tradeVoucher/TradeVoucherInvoiceInfo.vue
// module id = 1849
// module chunks = 1